import React, { createContext, useRef, useState } from "react";

const USQSUndoContext = createContext({});

export const USQSUndoProvider = ({ children }) => {
  const USQSEdits = useRef([]);
  const undoListUSQS = useRef([]);
  const [editIDUSQS, setEditIDUSQS] = useState(0);
  const [editingFieldUSQS, setEditingFieldUSQS] = useState(false);
  const [showcalculatorUSQS, setShowcalculatorUSQS] = useState();
  const inputRefsUSQS = useRef({});
  const [undoFocusFlagUSQS, setUndoFocusFlagUSQS] = useState();
  const [reloadpaytermsUSQS, setReloadpaytermsUSQS] = useState(false);

  return (
    <USQSUndoContext.Provider
      value={{
        USQSEdits,
        editIDUSQS,
        setEditIDUSQS,
        editingFieldUSQS,
        setEditingFieldUSQS,
        undoListUSQS,
        showcalculatorUSQS,
        setShowcalculatorUSQS,
        inputRefsUSQS,
        undoFocusFlagUSQS,
        setUndoFocusFlagUSQS,
        reloadpaytermsUSQS,
        setReloadpaytermsUSQS,
      }}
    >
      {children}
    </USQSUndoContext.Provider>
  );
};

export default USQSUndoContext;
